module.exports = __webpack_public_path__ + "img/50_5.3bc6c032.png";